export enum BroadcastType {
  OtherBroadcast = 0,
  Spotify = 1,
  Youtube = 2,
  Page = 3,
  StaticPage = 4,
  SubcategoryPage = 5,
}
